export const infamousCVE = [
  "Log4J",
  "RegreSShion",
  "ShellShock",
  "Spectre and Meltdown",
  "EternalBlue",
  "ZeroLogon",
  "Heartbleed",
  "Stuxnet",
];
